const HISTORICS = {
    SIM_CARDS: {
        COLLECTION: {
            queryKey: 'getSimCardsHistorics',
            url: '/history/sims'
        },
        EXPORT: {
            url: '/history/sims/export'
        }
    },
    POS_TERMINALS: {
        COLLECTION: {
            queryKey: 'getPosTerminalsHistorics',
            url: '/history/posTerminal'
        },
        EXPORT: {
            url: '/history/posTerminals/export'
        }
    },
    USERS: {
        COLLECTION: {
            queryKey: 'getUsersHistorics',
            url: '/history/users'
        },
        EXPORT: {
            url: '/history/users/export'
        }
    }
};

export default HISTORICS;